module.exports = __webpack_public_path__ + "img/confection.c562128c.svg";